
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const menuDrawer = document.querySelector('.menu-drawer__utility-links');
    const wishlist = document.querySelector('.Vtl-WishlistHeaderWrapper');
    
    if (window.innerWidth <= 750 && menuDrawer && wishlist) {
      const clone = wishlist.cloneNode(true);
      clone.classList.add('wishlist-mobile');
      menuDrawer.appendChild(clone);
    }
  }, 1000);
});
 
(function() {
  const moveWishlistToContainer = function() {
    const wishlistElement = document.querySelector('.header__icons > .Vtl-WishlistHeaderWrapper');
    const container = document.getElementById('wishlist-container');
    
    if (wishlistElement && container && wishlistElement.parentElement !== container) {
      container.appendChild(wishlistElement);
      return true;
    }
    return false;
  };

  if (moveWishlistToContainer()) return;

  const observer = new MutationObserver(function(mutations) {
    if (moveWishlistToContainer()) {
      observer.disconnect();
    }
  });

  const headerIcons = document.querySelector('.header__icons');
  if (headerIcons) {
    observer.observe(headerIcons, {
      childList: true,
      subtree: false
    });
  }

  setTimeout(function() {
    observer.disconnect();
  }, 5000);
})(); 